import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.2504 2.2488)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M10.7497 0C11.022 2.6555e-06 11.2727 0.147775 11.405 0.385742L21.405 18.3857C21.534 18.6179 21.5307 18.9009 21.3962 19.1299C21.2615 19.3589 21.0155 19.5 20.7497 19.5H0.749738C0.483998 19.5 0.238018 19.3589 0.103254 19.1299C-0.0312599 18.9009 -0.0345087 18.6179 0.0944646 18.3857L10.0945 0.385742C10.2268 0.147777 10.4774 1.19022e-08 10.7497 0ZM2.02318 18H19.4753L10.7497 2.29395L2.02318 18ZM10.7497 14.25C11.302 14.25 11.7497 14.6978 11.7497 15.25C11.7497 15.8023 11.302 16.25 10.7497 16.25C10.1975 16.25 9.74974 15.8023 9.74974 15.25C9.74978 14.6978 10.1975 14.25 10.7497 14.25ZM11.4997 12.75H9.99974V7.75H11.4997V12.75Z",
			fill: "currentColor"
		})
	})
});
export default SvgWarning;
